import { render } from "./ExerciseView.vue?vue&type=template&id=89903bd0"
import script from "./ExerciseView.vue?vue&type=script&lang=js"
export * from "./ExerciseView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__